import React from 'react';
import PropTypes from 'prop-types';
import Label from '../Label/Label.jsx';
import Tooltip from '../Tooltip/Tooltip.jsx';
import {colors} from '../../utils/colors.js';

const VARIANT_MAP = {
  UPSELL: 'success',
  PendingRequest: 'warning',
  REJECTED: 'danger',
  EXPIRED: 'danger',
};

const CUSTOM_STYLE_MAP = {
  CANCELLED: {backgroundColor: colors.warning, color: 'white'},
  OPENED: {backgroundColor: colors.tips20, color: colors.tips},
  CLICKED: {backgroundColor: colors.tips20, color: colors.tips},
  SENT: {backgroundColor: colors.tips, color: 'white'},
  IMPORTED: {backgroundColor: colors.grey64, color: 'white'},
  INCOMPLETE: {backgroundColor: colors.grey8, color: colors.grey},
  BLOCKED: {backgroundColor: colors.grey, color: 'white'},
};

const UpsellingBlockerCode = ({error}) => {
  if (!error) {
    return null;
  }

  const readableError = error.split('_').join(' ');
  const abbreviation = error.split('_').map(word => word[0]).join('');

  return (
    <Tooltip position="left" content={readableError}>
      <Label variant="danger" style={{fontSize: '9px', fontWeight: 'bold'}}>
        {abbreviation}
      </Label>
    </Tooltip>
  );
};

const UpsellStatusLabel = ({status, upsellingBlocker}) => {
  const variant = VARIANT_MAP[status];

  if (variant) {
    return (
      <Label variant={variant}>
        {status === 'PendingRequest' ? 'PENDING' : status}
      </Label>
    );
  }

  const customStyle = CUSTOM_STYLE_MAP[status];

  if (customStyle) {
    return (
      <>
        <Label backgroundColor={customStyle.backgroundColor} color={customStyle.color}>
          {status}
        </Label>
        {status === 'BLOCKED' && <UpsellingBlockerCode error={upsellingBlocker} />}
      </>
    );
  }

  return (
    <Label backgroundColor={colors.grey20} color={colors.grey}>
      {status}
    </Label>
  );
};

UpsellStatusLabel.propTypes = {
  status: PropTypes.string,
  upsellingBlocker: PropTypes.string,
};

export default UpsellStatusLabel;
